<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { isMobile } from "@/utils"
import { computed } from "vue"
import { DialogSize } from "./DialogEnum"
import type { ButtonOptionsType } from "./DialogInterface"
import CloseIcon from "@/assets/icons/close.svg?component"
import Button from "@/components/Button/Button.vue"
import { ButtonSize, ButtonType, ButtonVariant } from "./../Button/ButtonEnums"

const props = defineProps<{
   size: DialogSize
   buttons: ButtonOptionsType[]
   show: Boolean
}>()

const dialogSizeClass = computed(() => ({
   "modal-small": props.size === DialogSize.Small,
   "modal-medium": props.size === DialogSize.Medium,
   "modal-large": props.size === DialogSize.Large
}))

const emit = defineEmits(['close', 'confirm'])

type ButtonTypeKey = keyof typeof ButtonType

</script>

<template>
   <!-- eslint-disable vue/no-v-html -->
   <Transition name="modal">
      <div v-if="show" class="modal-overlay invicta" @click="$emit('close')">
         <div :class="['modal-container', isMobile() ? 'mobile' : dialogSizeClass]" @click.stop="">
            <div class="modal-content">
               <div class="modal-header">
                  <slot name="header"></slot>
                  <Button
                     class="modal-close-button"
                     :size="ButtonSize.Small"
                     :type="ButtonType.Link"
                     :variant="ButtonVariant.Icon"
                     :round="true"
                     @click="$emit('close')"
                  >
                     <close-icon />
                  </Button>
               </div>
               <div class="modal-body">
                  <slot name="body"></slot>
               </div>
            </div>
            <div :class="['modal-footer', isMobile() ? 'mobile' : '']">
               <slot name="footer">
                  <Button v-for="(button, index) in buttons" 
                     :key="index"
                     :type="ButtonType[button.type as ButtonTypeKey]"
                     :round="true" 
                     :uppercase="true"
                     :class="['modal-default-button', isMobile() ? 'mobile' : '']"
                     @click="$emit(button.event_name)"
                  >
                     {{button.text}}
                  </Button>
               </slot>
            </div>
         </div>
      </div>
   </Transition>
</template>
